import { Icon } from "@deligoo/ui"
import clsx from "clsx"

import { useAppSelector } from "@/App"
import { AsidePanel } from "@/components/AsidePanel"
import { Card } from "@/components/Card"
import { selectClientById } from "@/store/clients"
import { Order } from "@/types"

import cls from "../ClientContextMenu.module.scss"

type OrderDetailsPanelProps = {
  clientId: Order["id"]
  handleClose: () => void
}

export const ClientDetailsPanel = ({ clientId, handleClose }: OrderDetailsPanelProps) => {
  const client = useAppSelector(selectClientById(clientId))

  if (!client) return null

  return (
    <AsidePanel handleClose={handleClose} className={clsx(cls.orderDetailsPanel)}>
      <Card>
        <Card.Section className={cls.panelHeader}>
          <div>
            <div className="h400">{client.name}</div>

            <div className="text-desc font-weight-bold mt-3">
              <Icon name="restaurants" color="primary" size="small" className="mr-3" />
              ID: {client.id}
            </div>
          </div>

          <Card.Close handleClose={handleClose} />
        </Card.Section>

        <Card.Section>
          <dl>
            <dt>Indywidualny maks. czas dowozu zamówienia przez kuriera</dt>
            <dd>{client.max_delivery_time_individual ? `${client.max_delivery_time_individual} min.` : "-"}</dd>

            <dt>Indywidualny czas na obdiór zamówienia przez kuriera</dt>
            <dd>{client.pickup_duration_individual ? `${client.pickup_duration_individual} min.` : "-"}</dd>

            <dt>Maks. czas na łączenie zleceń</dt>
            <dd>{client.max_order_connection_time ? `${client.max_order_connection_time} min.` : "-"}</dd>

            <dt>Czas do przypisania zlecenia (bufor)</dt>
            <dd>{client.buffering_time ? `${client.buffering_time} min.` : "-"}</dd>

            <dt>Godziny pracy</dt>
            <dd>
              {client.start_working_hours} - {client.end_working_hours}
              {client.temporary_end_working_hours && <span>({client.temporary_end_working_hours})</span>}
            </dd>

            <dt>Limit odległości</dt>
            <dd>{client.deligoo_max_distance_limit} km</dd>

            <dt>Obsługiwanie rowerów</dt>
            <dd>
              <BooleanIcon value={client.transport_types.includes("bicycle")} />
            </dd>

            <dt>Obsługiwanie skuterów</dt>
            <dd>
              <BooleanIcon value={client.transport_types.includes("scooter")} />
            </dd>

            <dt>Obsługiwanie dostaw własnych</dt>
            <dd>
              <BooleanIcon value={client.own_delivery} />
            </dd>

            <dt>Automatyczne przyjmowanie zleceń (testowe)</dt>
            <dd>
              <BooleanIcon value={client.automatic_order_acceptance} />
            </dd>
          </dl>
        </Card.Section>
      </Card>
    </AsidePanel>
  )
}

const BooleanIcon = ({ value }: { value: boolean }) => {
  return value ? <Icon name="check-tiny" color="success" /> : <Icon name="close-tiny" color="alert" />
}
